import { useQuery } from '@tanstack/react-query';
import { proposalProjectApiConnect } from '../lib/api/proposalProjectApi.connect';
/**
 * Fetch shred view requirements with optional filtering.
 * Supports group names (instructions, scope, evaluation, etc.)
 * and individual RequirementCategory values (KEY_PERSONNEL, etc.)
 */ export function useShredView(projectId, category, filters) {
    const fullFilters = {
        ...filters,
        ...category && {
            category
        }
    };
    return useQuery({
        queryKey: [
            'shredView',
            projectId,
            fullFilters
        ],
        queryFn: ()=>proposalProjectApiConnect.getShredView(projectId, fullFilters),
        staleTime: 60000,
        enabled: !!projectId,
        retry: 1,
        placeholderData: {
            category: '',
            requirements: [],
            pagination: {
                page: 1,
                limit: 20,
                total: 0,
                pages: 0
            },
            stats: {
                total: 0,
                byStatus: {},
                byObligation: {},
                byCategory: {},
                mandatory: 0,
                evaluated: 0
            }
        }
    });
}
